module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("72kzx"))).then(() => parcelRequire('ikE14'));